import { defineEntity, lifecycle } from './_helpers.js';

/** Row updates only — no create/delete route. */
export default defineEntity('bigdesImplementationProcessEvaluation', {
    updated: lifecycle(),
}, { includeDefaultLifecycle: false });
